/**
 * 开通会员引导组件
 * 组件内置开通文档高亮逻辑
 */
import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';
import { IVipGuideExtensionOptions } from './types';


export enum VipGuideReportMethod {
    SHOW,
    CLICK,
}

export async function showDocsComponentVipGuide(options: IVipGuideExtensionOptions): Promise<void> {
    const vipGuideExtension = await ArkLoader.extensionService.getExtension(componentConfig.name);
    vipGuideExtension.show(options);
}

export async function loadAndShowDocsComponentVipGuide(options: IVipGuideExtensionOptions): Promise<void> {
    await ArkLoader.extensionService.scanAndHandleExtensions([componentConfig]);
    const vipGuideExtension = await ArkLoader.extensionService.getExtension(componentConfig.name);
    vipGuideExtension.show(options);
}
